import React from "react";
import styled from "styled-components";
import { Media } from "../../../components/Media";
import { ContentEngagement } from "../../../components/ContentEngagement";
import { AspectRatio } from "../../../components/AspectRatio";
import { getMediaAspectRatio } from "../../../functional/getMediaAspectRatio";
const youtubeLightbox = true;
const SideMediaItem = ({ media, action }) => {
    const mediaElement = (React.createElement(Media, { "data-testid": "featured-media", media: media, draggable: false, youtubeLightbox: youtubeLightbox, controls: true }));
    const mediaElementWithOptionalAspectRatio = media.type === "video" && media.provider === "youtube" && !youtubeLightbox ? (React.createElement(AspectRatio, { ratio: getMediaAspectRatio(media, 16 / 9) }, mediaElement)) : (mediaElement);
    return action ? (React.createElement(ContentEngagement, { action: action, contentAnalytics: {
            id: "richTextSideMedia",
            uiType: "richTextSideMedia",
        } }, mediaElementWithOptionalAspectRatio)) : (mediaElementWithOptionalAspectRatio);
};
export const ArticleRichTextSideMedia = styled(SideMediaItem) ``;
//# sourceMappingURL=SideMedia.js.map